import dataProcesses from './dataProcesses'
import companies from './companies'
import departments from './departments'
import lastUpdates from './lastUpdates'

const queries = { dataProcesses, companies, departments, lastUpdates }

export default queries
